export default __webpack_public_path__ + "static/media/alarm-clock.e6637c70.woff2";